import { type FeatureFlag, isFeatureFlagEnabled } from '@seen/core/featureFlags'
import { useContext } from 'react'
import { FeatureFlagContext } from '#src/contexts/feature-flags/FeatureFlagContext.tsx'

export function useFeatureFlag(flag: FeatureFlag): boolean {
  const values = useContext(FeatureFlagContext)
  return isFeatureFlagEnabled(values, flag)
}
